<template>
    <div class="tv-test-card">
        <div id="black"></div>
        <div id="red"></div>
        <div id="pink"></div>
        <div id="green"></div>
        <div id="blue"></div>
        <div id="yellow"></div>
        <div id="white" :class="videoSoundToggle && 'container'">
            <div v-if="videoSoundToggle" class="sound-toggle-btn" @click="videoSoundToggle">
                <span>Click For Sound</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        videoSoundToggle: Function
    }
}
</script>

<style>
    .container {
        position: relative;
    }

    .sound-toggle-btn {
        height: 45px !important;
        width: 45px !important;
        position: absolute;
        top: 50%; left: 50%;
        transform: translate(-50%, -50%);
        background-color: #FF0000;;
        border-radius: 100%;
        border: 2px solid #FF0000;;
        cursor: pointer;
        display: -webkit-flex; display: -ms-flexbox; display: flex; 
        align-items: center;
        justify-content: center;
        transition: all 300ms cubic-bezier(0.075, 0.82, 0.165, 1);
    }

    .sound-toggle-btn:hover {
        background-color: black;
        color: white;
    }

    .sound-toggle-btn:active, .sound-toggle-btn:focus, .sound-toggle-btn:active span {
        background-color: white;
        color: black;
    }

    .sound-toggle-btn span {
        font-size: 8px;
        text-align: center;
        font-family: 'Helvetica-Rounded';
        color: white;
        transform: rotate(15deg);
        border-radius: 100%;
    }
</style>
